// Ambient archetype (MOB-2 ambient: bat, M13.1). PURE (ENG-1).
//
// A harmless flier that flutters in 3D through caves. It shares the flying-mob
// physics (gravity-free; velocity eases toward the wish vector) but has no target
// and never attacks — it just drifts, staying off the floor and out of walls.
import { FLYING } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext, MobWorld } from '../entity';

/** Solid directly below within a few blocks → nudge upward off the floor. */
function nearFloor(world: MobWorld, e: Entity): boolean {
  const ix = Math.floor(e.x), iz = Math.floor(e.z);
  return world.isSolid(ix, Math.floor(e.y) - 1, iz) || world.isSolid(ix, Math.floor(e.y) - 2, iz);
}

export function ambient(e: Entity, _def: MobDef, ctx: MobContext): void {
  const { world } = ctx;
  // Re-pick a fluttering heading periodically (3D).
  if (--e.wanderTimer <= 0) {
    e.wanderTimer = FLYING.WANDER_INTERVAL + ctx.rng.nextInt(FLYING.WANDER_INTERVAL);
    e.wanderAngle = ctx.rng.nextFloat() * Math.PI * 2;
    e.data.wishV = (ctx.rng.nextFloat() - 0.5) * 0.6; // gentle up/down drift
  }
  const speed = FLYING.MAX_SPEED * 0.6;
  e.wishX = Math.cos(e.wanderAngle) * speed;
  e.wishZ = Math.sin(e.wanderAngle) * speed;
  // Bias upward off the floor, downward from the ceiling; else drift by wishV.
  let vy = (e.data.wishV ?? 0) * speed;
  if (nearFloor(world, e)) vy = speed;
  else if (world.isSolid(Math.floor(e.x), Math.floor(e.y) + 2, Math.floor(e.z))) vy = -speed;
  e.wishY = vy;
}
